import { Search } from "react-feather";
import CardEvent from "../../component/CardEvent";
import AccountBar from "../../component/AccountBar";
import { useCallback, useEffect, useMemo, useState } from "react";
import secureLocalStorage from "react-secure-storage";
import { partner } from "../GlobalEndpoin";
import { getPartnerName } from "../../helper";
import toast from "react-hot-toast";

const Home = () => {
  const [dataEvent, setDataEvent] = useState([]);
  const [searchVal, setSearchVal] = useState("");
  const [partnerName, setPartnerName] = useState("");

  const handleCheckToken = useCallback(async () => {
    try {
      const res = await partner({
        token_partnership: secureLocalStorage.getItem("tokenPartner"),
      });
      if (res.status) {
        setDataEvent(res.data);
        setPartnerName(getPartnerName(res));
      } else {
        toast.error("Akun Tidak Dikenali");
      }
    } catch (error) {}
  }, []);

  useEffect(() => {
    handleCheckToken();
  }, [handleCheckToken]);

  const filteredEvent = useMemo(() => {
    const q = searchVal.trim().toLowerCase();
    if (!q) return dataEvent;
    return dataEvent?.filter((item) =>
      (item?.[0]?.information?.title || "").toLowerCase().includes(q)
    );
  }, [dataEvent, searchVal]);

  return (
    <div className="home-wrap">
      <AccountBar name={partnerName} />

      <div className="home-search">
        <Search color="var(--primary-color)" size={18} />
        <input
          placeholder="Cari event"
          value={searchVal}
          onChange={(e) => setSearchVal(e.target.value)}
        />
      </div>

      <h2 className="home-section-title">Event Tersedia</h2>

      {filteredEvent?.length > 0 ? (
        filteredEvent.map((item, index) => (
          <CardEvent item={item} key={index} />
        ))
      ) : (
        <p className="home-empty">
          {searchVal ? "Event tidak ditemukan" : "Belum ada event"}
        </p>
      )}
    </div>
  );
};

export default Home;
